import { number } from '@glu/core';
import locale from '@glu/locale';
import date from 'moment';
import numeral from 'numeral';
import 'numeralLocales';

/**
 * add backward compatibility with existing glu locale set
 * @param name
 * @param numbers
 * @returns {*}
 */
number.language = function language(name, numbers) {
  if (!numbers) {
    return number.locale(name);
  }

  return number.register('locale', name, numbers);
};
/**
 * add backward compatibility with existing glu locale set
 * @returns {*}
 */
number.languageData = function languageData(...args) {
  return number.localeData(...args);
};

/**
 * Add backward compatibility for the unformat method to numeral.js
 * @param value
 * @returns {*}
 */
number.fn.unformat = value => number(value).value();

locale.loadBrowserLocale = () => {
  const browserLocale = navigator?.language?.replace(/_/g, '-').toLowerCase() || navigator?.userLanguage?.replace(/_/g, '-').toLowerCase() || 'en-us';
  date.locale(browserLocale);

  if (numeral.locales[browserLocale]) {
    numeral.locale(browserLocale);
    return;
  }

  const isoParts = browserLocale.split('-');
  if (isoParts.length === 2 && isoParts[0] !== 'en' && numeral.locales[isoParts[0]]) {
    numeral.locale(browserLocale);
  }
};

export default locale;
